import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-submit_icon",
  "use": "icon-submit_icon-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-submit_icon\">\r\n<path d=\"M0 7C0 6.35567 0.522334 5.83333 1.16667 5.83333H12.8333C13.4777 5.83333 14 6.35567 14 7C14 7.64433 13.4777 8.16667 12.8333 8.16667H1.16667C0.522334 8.16667 0 7.64433 0 7Z\" fill=\"white\" />\r\n<path d=\"M7 0C7.64433 2.81647e-08 8.16667 0.522334 8.16667 1.16667L8.16667 12.8333C8.16667 13.4777 7.64433 14 7 14C6.35567 14 5.83333 13.4777 5.83333 12.8333L5.83333 1.16667C5.83333 0.522334 6.35567 -2.81647e-08 7 0Z\" fill=\"white\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/submit_icon.svg
// module id = C9Uq
// module chunks = 14